<template>
  <v-dialog v-model="dialog" max-width="800px" scrollable>
    <template v-slot:activator="{ on }">
      <div>
        <a v-if="!disabled" v-on="on">{{ $tc('campanhas.variaveis', 2) }}</a>
        <mf-tooltip v-else top max-width="250px">
          <template #activator="{ on: onTooltip }">
            <a class="disabled-button" v-on="onTooltip">{{ $tc('campanhas.variaveis', 2) }}</a>
          </template>
          <span>{{ tooltipText }}</span>
        </mf-tooltip>
      </div>
    </template>

    <v-card>
      <v-card-title>
        <p class="title mb-0">Variáveis: use-as para facilitar a personalização</p>
      </v-card-title>

      <v-card-text ref="exampleMessage" class="pa-4 mt-n2">
        <v-row v-for="(variable, index) in variables" :key="index" class="ma-0">
          <v-col v-if="!variable.variableWithinVariable && !(variable.channels && !variable.channels.includes(channel))" cols="4">
            <v-row justify="end">
              <v-chip class="px-4 py-5" large color="cinza-l90">
                <v-select
                  v-if="variable.text === 'Melhor produto' || variable.text === 'Melhor combo'"
                  v-model="bestItem"
                  :items="items"
                  item-text="description"
                  item-value="value"
                />
                <span class="text-color">{{ variable.text }}</span>
                <mf-icon v-clipboard="() => variable.clipboardText" color="cinza-d10" class="secondary-text cursor-pointer ml-1" right @success="handleSuccess">
                  content_copy
                </mf-icon>
              </v-chip>
            </v-row>
          </v-col>
          <v-col
            v-if="!variable.variableWithinVariable && !(variable.channels && !variable.channels.includes(channel))"
            cols="8"
            class="mt-n1 d-flex align-center"
          >
            <div>
              <span class="column-title">{{ variable.description }}</span>
              <p class="subtitle mt-n1" style="margin: 0">
                Contabiliza {{ variable.charQuantity }} dígitos.
                <span v-if="variable.text === 'Melhor produto' || variable.text === 'Melhor combo'">O texto proposto pode ser editado</span>
              </p>
            </div>
          </v-col>
        </v-row>

        <p class="mt-3 mb-1">Exemplo:</p>
        <p class="ma-0">
          "<span class="texto-corrido-destaque">[primeiro nome]</span>, fim de semana combina com cerveja e churrasco. Promoção de Carnes em nosso açougue e
          Skol Lata 350ml por R$1,99 até <span class="texto-corrido-destaque">[data hoje]</span>
        </p>

        <p class="mt-3 mb-1">Resultado:</p>
        <p class="ma-0">
          "<span class="texto-corrido-destaque">Marcos</span>, fim de semana combina com cerveja e churrasco. Promoção de Carnes em nosso açougue e cerveja Skol
          Lata 350ml por R$1,99 até <span class="texto-corrido-destaque">{{ today }}</span
          >"
        </p>
        <mf-action-buttons
          class="mt-2"
          :primary-button="{
            text: 'Fechar',
            action: () => (dialog = false),
            isVisible: true,
          }"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { characterVariables } from '@/mixins/character-variables'

export default {
  name: 'MessageVariables',
  mixins: [characterVariables],
  props: {
    channel: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    tooltipText: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    dialog: false,
    bestItem: 1,
    items: [
      {
        value: 1,
        description: '1°',
      },
      {
        value: 2,
        description: '2°',
      },
      {
        value: 3,
        description: '3°',
      },
    ],
  }),
  watch: {
    bestItem() {
      this.getClipboardTextBestItem(this.bestItem)
    },
  },
  methods: {
    handleSuccess(e) {
      this.$snackbar({ message: 'Copiado para área de transferencia', snackbarColor: 'info' })
    },
  },
}
</script>
<style lang="scss" scoped>
.title {
  font-weight: bold;
  font-size: 26px;
  line-height: 120%;

  color: $cinza-d10;
}

a {
  color: $marca-0-l40;
  text-decoration-line: underline;
  font-size: 14px;
}

.disabled-button {
  color: rgba(0, 0, 0, 0.26);
  pointer-events: none;
  cursor: default;
}

.text-color {
  color: $cinza-d20;
}

.cursor-pointer {
  cursor: pointer;
}

div.v-card__text.pa-4.mt-n2 > div > div.col.col-4 > div > span {
  background-color: $cinza-l90 !important;
  color: $cinza-0;
}

.v-list.v-select-list.v-sheet.v-sheet--tile.theme--light.theme--light {
  background-color: $cinza-l80 !important;
}

::v-deep .v-list-item__title {
  text-align: center;
}

::v-deep .v-chip {
  height: 48px;
}

::v-deep .v-select__selection.v-select__selection--comma {
  margin-left: 10px;
  color: $cinza-d20;
}

::v-deep .v-input__icon.v-input__icon--append {
  margin-right: 7px;
  i {
    color: $cinza-d20;
  }
}

::v-deep div.v-input__slot {
  width: 66px;
  height: 39px;
  top: 3px;
  left: -10px;

  background: $cinza-l80;
  border-radius: 16px;
}

::v-deep div.v-input__slot::before {
  background: $cinza-l80;
  border-radius: 16px;
  width: 66px;
  height: 39px;
}

::v-deep div.v-input__slot::before {
  content: none !important;
}

::v-deep .v-text-field > .v-input__control > .v-input__slot:after,
.v-text-field > .v-input__control > .v-input__slot:before {
  content: none !important;
}
</style>
